import { useSubscription } from '@apollo/client';

import { GET_SUBMISSIONS_EVENTS } from './submissions.subscription';

export function useQuoteSubscriptionQuery() {
  const { loading, error, data } = useSubscription(GET_SUBMISSIONS_EVENTS);

  const updateQuoteEventNotice =
    data &&
    data.events.__typename === 'SubscriptionEventModel' &&
    data.events.eventNotice?.noticeArea === 'Default Quote Options' &&
    data.events.eventNotice?.noticeName === 'status' &&
    data.events.eventNotice?.noticeValue === 'completed';

  return {
    updateQuoteEventNotice,
    loading,
    error,
    data,
  };
}
